import type { TypeformConfig } from "./types";

export const TypeformConfigMap = {
  READ_MORE_SURVEY: {
    // cspell:disable-next-line
    id: "Y25RZhCu",
    key: "scmp-econ-article-read-more-typeform-is-shown",
    shouldAutoOpen: {
      desktop: false,
      mobile: true,
    },
    treatAsFinished: "onSubmit",
  },
  SEARCH_RESULT: {
    // cspell:disable-next-line
    id: "nmaHYBYA",
    key: "scmp-search-result-csat-typeform-is-shown",
    shouldAutoOpen: {
      desktop: false,
      mobile: false,
    },
    treatAsFinished: "onSubmit",
    variant: {
      sidetab: {
        buttonText: "Share your feedback",
        hideIcon: {
          desktop: false,
          mobile: true,
          tablet: true,
        },
      },
    },
  },
} satisfies Record<string, TypeformConfig>;
